import moment from 'moment';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import React, { Component } from 'react'
import Authentication from './../session';
import { connect } from 'react-redux';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

class FeeReciept extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reciept: {}
        }
    }
    render() {
        const { receiptData, isRefundReceipt } = this.props;

        const { logoRectangle, orgName, orgAddress, mobileOperational } = this.props;
        console.log(this.props, 'recieptnew')

        return (
            <>
                <Dialog
                    style={{ width: '90%' }}
                    header={isRefundReceipt ? 'Refund Receipt' : 'Fee Receipt'}
                    modal
                    footer={() => {
                        return <>
                            <ReactToPrint
                                pageStyle={`
                                    @page { 
                                        size: portrait;
                                        // margin: 10px;
                                        // position: relative;
                                    }
                                    @media print {
                                        .flex.justify-between {
                                            display: flex;
                                            flex-direction: row;
                                            transform: rotate(270deg);
                                            // align-items: center;
                                            // position: absolute;
                                            // height: 100vh !important;
                                            
                                        }
                                         .logo-img {
                                            width: 80px;
                                            height: 40px;
                                            margin-left: 20%;
                                            margin-top: 10px;
                                        }
         
                                            .container {
                                                height: 100vh !important; /* Set the height to the full viewport height */
                                                min-width: 100vh !important;
                                                width: 100vw !important; /* Ensure it spans the full width of the viewport */
                                            // border: 5px solid red !important; /* Keep the border for visibility */
                                                box-sizing: border-box; /* Include padding and border in the element's dimensions */
                                            }

                                            .office-container{
                                            width: 48vh !important;
                                            height: 100vw !important; 
                                            border: 1px solid black !important;
                                            }
                                            .parent-container{
                                                width: 48vh !important;
                                                height: 100vw !important; 

                                            border: 1px dashed black !important;
                                            }
                                            h2{
                                                font-size: 30px !important;
                                            }
                                            h5{
                                                font-size: 16px !important;
                                                margin: 0 !important;
                                                padding: 0 !important;
                                            }
                                            h6{
                                               line-height: 1 !important;
                                                font-size: 14px !important;
                                                 wordWrap: 'break-word';
                                                overflowWrap: 'break-word';
                                                wordBreak: 'break-word';
                                                whiteSpace: 'normal';
                                            }
                                            h3 {
                                                font-size: 20px !important;
                                                margin: 0 !important;
                                                padding: 0 !important;
                                            }
                                            
                                            .heading-font{
                                            font-size: 15px !important;
                                            }
                                            .payinfo {
                                                wordBreak: break-word !important;
                                                overflowWrap: break-word !important;
                                                white-space: normal !important;
                                            }
                                        

                                    
                                `}
                                content={() => this.componentRef}>
                                <PrintContextConsumer>
                                    {({ handlePrint }) => (
                                        <>  <Button data-pr-position="bottom"
                                            data-pr-tooltip="Download "
                                            onClick={handlePrint}
                                            className='print-button ma-mr20 p-ml-10 p-mb-4'
                                            label='Print'
                                        ></Button>
                                            <Tooltip className="table-li-tooltip" target=".egraph" />
                                        </>
                                    )}
                                </PrintContextConsumer>
                            </ReactToPrint>
                        </>
                    }}
                    draggable={false}
                    blockScroll={true}
                    closeOnEscape={false}
                    dismissableMask={false}
                    visible={true}
                    closable={true}
                    onHide={this.props.hideFeeReciept}
                >
                    <div className='flex justify-between ma-m20 container' ref={(el) => this.componentRef = el}>
                        <div className='office-container' style={{ width: '48%', border: '1px solid' }}>
                            <div className='flex'>
                                <div className='w-30 ma-mt10' >
                                    <img src={`${logoRectangle?.storageLocation}`} className='logo-img' style={{ marginLeft: '10%' }} />
                                </div>
                                <div className='flex justify-center w-70'>
                                    <div>
                                        <div className='flex justify-center'>
                                            <h2 className='p-mb-2 orgHeader' >{orgName}</h2>
                                        </div>
                                        <h4 className='heading-font'>{orgAddress}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className='w-100'>
                                <hr className='dashed' />
                            </div>
                            <div className='flex justify-end mr-3' >
                                <h5>Office Copy</h5>
                            </div>
                            <div className='flex justify-center mb-3'>
                                <h3>{receiptData?.receiptType === "acknowledgement" ? "Acknowledgement" : isRefundReceipt ? 'Refund Receipt' : receiptData?.receiptName || "Fee Receipt"}</h3>
                            </div>
                            <div className='ml-3' >
                                <div className='flex'>
                                    <div className='w-60'>
                                        <div className='mb-1'>
                                            <p className='payinfo'>NAME OF THE STUDENT : {receiptData?.studentName || receiptData?.given_name}</p>
                                            {/* <p className='payinfo'>PARENT NAME : {receiptData?.parentName}</p> */}
                                            {/* <p className='payinfo'>ENROLLMENT ID : {receiptData?.username}</p> */}
                                            {/* <p className='payinfo'>ACADEMIC YEAR : {receiptData?.academicYear || receiptData?.academicCode}</p> */}
                                            {/* <p className='payinfo'>ADMISSION CATEGORY : {receiptData?.admissionCategory}</p> */}
                                            <p className='payinfo'>CLASS NAME : {receiptData?.className || receiptData?.gradeName}</p>
                                        </div>
                                    </div>
                                    <div className='w-40'>
                                        <div className='mb-1'>
                                            <p className='payinfo'>RECEIPT NUMBER : {receiptData?.receiptNo}</p>
                                            <p className='payinfo'>RECEIPT DATE : {moment(receiptData?.date || receiptData?.receiptDate).format('DD-MM-YYYY')}</p>
                                            {/* <p className='payinfo'>TRANSACTION DATE : {moment(receiptData?.transactionDate || receiptData?.date || receiptData?.receiptDate).format('DD-MM-YYYY')}</p> */}
                                            {!isRefundReceipt && (
                                                <>
                                                    <p className='payinfo'>PAYMENT MODE : {receiptData?.paymentMode}</p>
                                                    {/* {receiptData?.paymentMode === 'Online' 
                                                        (
                                                            <p className='payinfo'>TRANSACTION ID : {receiptData?.transctionId}</p>
                                                        )} */}
                                                    {/* {receiptData?.paymentMode === 'QR Code'
                                                        (
                                                            <p className='payinfo'>TRANSACTION ID : {receiptData?.transctionId}</p>
                                                        )} */}
                                                    {receiptData?.paymentMode !== 'Cash' &&
                                                        receiptData?.paymentMode !== 'Cheque' &&
                                                        receiptData?.paymentMode !== 'DD' && (
                                                            <p className='payinfo'>TRANSACTION ID : {receiptData?.transactionId}</p>
                                                        )}
                                                    {(receiptData?.paymentMode === 'Credit Card' ||
                                                        receiptData?.paymentMode === 'Debit Card') && (
                                                            <>
                                                                <p className='payinfo'>CARD LAST 4 DIGITS : {receiptData?.cardNo}</p>
                                                                <p className='payinfo'>APPROVAL CODE : {receiptData?.approvalCode}</p>
                                                                <p className='payinfo'>BANK NAME : {receiptData?.userBankName}</p>
                                                                <p className='payinfo'>RR NUMBER : {receiptData?.rrNumber}</p>
                                                            </>
                                                        )}

                                                    {receiptData?.paymentMode === 'Cheque' && (
                                                        <>
                                                            <p className='payinfo'>CHEQUE NO : {receiptData?.chequeNo}</p>
                                                            <p className='payinfo'>ISSUED TO: {receiptData?.chequeIssuedTo}</p>
                                                            <p className='payinfo'>CHEQUE DATE : {moment(receiptData?.chequeDate).format('DD-MM-YYYY')}</p>
                                                            <p className='payinfo'>BANK NAME : {receiptData?.bankName}</p>
                                                            <p className='payinfo'>BRANCH NAME : {receiptData?.bankBranchName}</p>
                                                        </>
                                                    )}
                                                    {receiptData?.paymentMode === 'DD' && (
                                                        <>
                                                            <p className='payinfo'>DD NO : {receiptData?.ddNo}</p>
                                                            <p className='payinfo'>ISSUED TO: {receiptData?.ddIssuedTo}</p>
                                                            <p className='payinfo'>DD DATE : {moment(receiptData?.ddDate).format('DD-MM-YYYY')}</p>
                                                            <p className='payinfo'>BANK NAME : {receiptData?.bankName}</p>
                                                            <p className='payinfo'>BRANCH NAME : {receiptData?.bankBranchName}</p>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='flex'>
                                    {receiptData?.remarks?.includes('|') ? (
                                        <div className='w-100'>
                                            <p className='payinfo'>REMARKS : {receiptData?.remarks?.split('|').map((remark, index) => (
                                                <span key={index}>
                                                    {remark}
                                                    <br />
                                                </span>
                                            ))}</p>
                                        </div>
                                    ) : (
                                        <div className='w-100'>
                                            <p className='payinfo'>REMARKS : {receiptData?.remarks}</p>
                                        </div>
                                    )}
                                </div>

                                <div className='mr-3'>
                                    <table className='table-border1 w-100 '>
                                        <tr>
                                            <th className='table-border heading-font w-1'>S.no</th>
                                            <th className='table-border heading-font'>Particulars</th>
                                            {!isRefundReceipt ? (<>
                                                <th className='table-border heading-font'>Amount</th>
                                                <th className='table-border heading-font'>Fine</th>
                                                <th className='table-border heading-font'>GST</th></>) :
                                                <th className='table-border heading-font'>Refund Amount</th>
                                            }
                                        </tr>
                                        {receiptData?.feePaidDetails?.map((e, i) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td className='table-border heading-font'>{i + 1}</td>
                                                        <td className='table-border heading-font'> {(e.term && !e.isOneTime) ? `${e.feeType} - ${e.paymentTerm}` : e.feeType}</td>
                                                        {!isRefundReceipt ? (<>
                                                            <td className='table-border heading-font'>{(e.amountPaying || 0).toFixed(2)}</td>
                                                            <td className='table-border heading-font'>{(e?.fineAmtPaying || 0).toFixed(2)}</td>
                                                            <td className='table-border heading-font'>{(e?.gstPaidNow || 0).toFixed(2)}</td></>) :
                                                            <td className='table-border heading-font'>{(e.refundAmt || 0).toFixed(2)}</td>
                                                        }
                                                    </tr>
                                                </>
                                            )
                                        })}

                                        <tr>
                                            <td className='table-border heading-font totalAmt' colSpan='5'>
                                                {!isRefundReceipt
                                                    ? `Total Amount Paid - ${(receiptData?.amountPaid || 0).toFixed(2)}`
                                                    : `Total Refund Amount - ${receiptData?.feePaidDetails?.reduce((sum, row) => sum + (Number(row.refundAmt) || 0), 0).toFixed(2)}`
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                    <div>
                                        <h6>Note : <span>Parents are
                                            requested to preserve this receipt for future clarifications in respect of fee paid
                                            by you. Fee once paid will not be refunded or transferred. Cheques subject to
                                            realization</span></h6>
                                    </div>
                                    <div className='flex justify-end mt-7'>
                                        <h6 >Cashier/Manager</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='parent-container' style={{ width: '48%', border: '1px dashed' }}>
                            <div className='flex'>
                                <div className='w-30 ma-mt10' >
                                    <img src={`${logoRectangle?.storageLocation}`} className='logo-img' style={{ marginLeft: '10%' }} />
                                </div>
                                <div className='flex justify-center w-70'>
                                    <div>
                                        <div className='flex justify-center'>
                                            <h2 className='p-mb-2 orgHeader' >{orgName}</h2>
                                        </div>
                                        <h4 className='heading-font'>{orgAddress}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className='w-100'>
                                <hr className='dashed' />
                            </div>
                            <div className='flex justify-end mr-3'>
                                <h5>Parent Copy</h5>
                            </div>
                            <div className='flex justify-center mb-3'>
                                <h3>{receiptData?.receiptType === "acknowledgement" ? "Acknowledgement" : isRefundReceipt ? 'Refund Receipt' : receiptData?.receiptName || "Fee Receipt"}</h3>
                            </div>
                            <div className='ml-3' >
                                <div className='flex'>
                                    <div className='w-60'>
                                        <div className='mb-1'>
                                            <p className='payinfo'>NAME OF THE STUDENT : {receiptData?.studentName || receiptData?.given_name}</p>
                                            {/* <p className='payinfo'>PARENT NAME : {receiptData?.parentName}</p> */}
                                            {/* <p className='payinfo'>ENROLLMENT ID : {receiptData?.username}</p> */}
                                            {/* <p className='payinfo'>ACADEMIC YEAR : {receiptData?.academicYear || receiptData?.academicCode}</p> */}
                                            {/* <p className='payinfo'>ADMISSION CATEGORY : {receiptData?.admissionCategory}</p> */}
                                            <p className='payinfo'>CLASS NAME : {receiptData?.className || receiptData?.gradeName}</p>
                                        </div>
                                    </div>
                                    <div className='w-40'>
                                        <div className='mb-1'>
                                            <p className='payinfo'>RECEIPT NUMBER : {receiptData?.receiptNo}</p>
                                            <p className='payinfo'>RECEIPT DATE : {moment(receiptData?.date || receiptData?.receiptDate).format('DD-MM-YYYY')}</p>
                                            {/* <p className='payinfo'>TRANSACTION DATE : {moment(receiptData?.transactionDate || receiptData?.date || receiptData?.receiptDate).format('DD-MM-YYYY')}</p> */}
                                            {!isRefundReceipt && (
                                                <>
                                                    <p className='payinfo'>PAYMENT MODE : {receiptData?.paymentMode}</p>
                                                    {receiptData?.paymentMode !== 'Cash' &&
                                                        receiptData?.paymentMode !== 'Cheque' &&
                                                        receiptData?.paymentMode !== 'DD' && (
                                                            <p className='payinfo'>TRANSACTION ID : {receiptData?.transactionId}</p>
                                                        )}
                                                    {(receiptData?.paymentMode === 'Credit Card' ||
                                                        receiptData?.paymentMode === 'Debit Card') && (
                                                            <>
                                                                <p className='payinfo'>CARD LAST 4 DIGITS : {receiptData?.cardNo}</p>
                                                                <p className='payinfo'>APPROVAL CODE : {receiptData?.approvalCode}</p>
                                                                <p className='payinfo'>BANK NAME : {receiptData?.userBankName}</p>
                                                                <p className='payinfo'>RR NUMBER : {receiptData?.rrNumber}</p>
                                                            </>
                                                        )}

                                                    {receiptData?.paymentMode === 'Cheque' && (
                                                        <>
                                                            <p className='payinfo'>CHEQUE NO : {receiptData?.chequeNo}</p>
                                                            <p className='payinfo'>ISSUED TO: {receiptData?.chequeIssuedTo}</p>
                                                            <p className='payinfo'>CHEQUE DATE : {moment(receiptData?.chequeDate).format('DD-MM-YYYY')}</p>
                                                            <p className='payinfo'>BANK NAME : {receiptData?.bankName}</p>
                                                            <p className='payinfo'>BRANCH NAME : {receiptData?.bankBranchName}</p>
                                                        </>
                                                    )}
                                                    {receiptData?.paymentMode === 'DD' && (
                                                        <>
                                                            <p className='payinfo'>DD NO : {receiptData?.ddNo}</p>
                                                            <p className='payinfo'>ISSUED TO: {receiptData?.ddIssuedTo}</p>
                                                            <p className='payinfo'>DD DATE : {moment(receiptData?.ddDate).format('DD-MM-YYYY')}</p>
                                                            <p className='payinfo'>BANK NAME : {receiptData?.bankName}</p>
                                                            <p className='payinfo'>BRANCH NAME : {receiptData?.bankBranchName}</p>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='flex'>
                                    {receiptData?.remarks?.includes('|') ? (
                                        <div className='w-100'>
                                            <p className='payinfo'>REMARKS : {receiptData?.remarks?.split('|').map((remark, index) => (
                                                <span key={index}>
                                                    {remark}
                                                    <br />
                                                </span>
                                            ))}</p>
                                        </div>
                                    ) : (
                                        <div className='w-100'>
                                            <p className='payinfo'>REMARKS : {receiptData?.remarks}</p>
                                        </div>
                                    )}
                                </div>

                                <div className='mr-3'>
                                    <table className='table-border1 w-100 '>
                                        <tr>
                                            <th className='table-border heading-font w-1'>S.no</th>
                                            <th className='table-border heading-font'>Particulars</th>
                                            {!isRefundReceipt ? (<>
                                                <th className='table-border heading-font'>Amount</th>
                                                <th className='table-border heading-font'>Fine</th>
                                                <th className='table-border heading-font'>GST</th></>) :
                                                <th className='table-border heading-font'>Refund Amount</th>
                                            }
                                        </tr>
                                        {receiptData?.feePaidDetails?.map((e, i) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td className='table-border heading-font'>{i + 1}</td>
                                                        <td className='table-border heading-font'> {(e.term && !e.isOneTime) ? `${e.feeType} - ${e.paymentTerm}` : e.feeType}</td>
                                                        {!isRefundReceipt ? (<>
                                                            <td className='table-border heading-font'>{(e.amountPaying || 0).toFixed(2)}</td>
                                                            <td className='table-border heading-font'>{(e?.fineAmtPaying || 0).toFixed(2)}</td>
                                                            <td className='table-border heading-font'>{(e?.gstPaidNow || 0).toFixed(2)}</td></>) :
                                                            <td className='table-border heading-font'>{(e.refundAmt || 0).toFixed(2)}</td>
                                                        }
                                                    </tr>
                                                </>
                                            )
                                        })}

                                        <tr>
                                            <td className='table-border heading-font totalAmt' colSpan='5'>
                                                {!isRefundReceipt
                                                    ? `Total Amount Paid - ${(receiptData?.amountPaid || 0).toFixed(2)}`
                                                    : `Total Refund Amount - ${receiptData?.feePaidDetails?.reduce((sum, row) => sum + (Number(row.refundAmt) || 0), 0).toFixed(2)}`
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                    <div>
                                        <h6>Note : <span>Parents are
                                            requested to preserve this receipt for future clarifications in respect of fee paid
                                            by you. Fee once paid will not be refunded or transferred. Cheques subject to
                                            realization</span></h6>
                                    </div>
                                    <div className='flex justify-end mt-7'>
                                        <h6 >Cashier/Manager</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    logoRectangle: state.orgData.logoRectangle,
    orgName: state.orgData.name,
    orgAddress: state.orgData.address,
    mobileOperational: state.orgData.mobileOperational,
});

export default connect(mapStateToProps, {})(
    Authentication(FeeReciept)
);